module.exports = __webpack_public_path__ + "img/aboutus.6846203d.jpg";